import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Lazy load pages for better performance
const HomePage = React.lazy(() => import('./pages/HomePage'));
const Dashboard = React.lazy(() => import('./pages/Dashboard'));
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const SignupPage = React.lazy(() => import('./pages/SignupPage'));
const KYCVerification = React.lazy(() => import('./pages/KYCVerification'));
const EducationHub = React.lazy(() => import('./pages/EducationHub'));
const TradeMarketplace = React.lazy(() => import('./pages/TradeMarketplace'));
const OrderTracking = React.lazy(() => import('./pages/OrderTracking'));
const AdminPanel = React.lazy(() => import('./pages/AdminPanel'));
const ProductListing = React.lazy(() => import('./pages/ProductListing'));
// --- NEW UPDATE ADDED ---
const ForgotPassword = React.lazy(() => import('./pages/ForgotPassword'));
// --- END UPDATE ---

// Simple loading component (temporary)
const LoadingSpinner = () => (
  <div className="flex justify-center items-center h-screen">
    <div className="w-16 h-16 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function PrivateRoute({ children }) {
  const { user, isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const { user, isAuthenticated } = useAuth();
  return isAuthenticated && user?.role === 'admin' ? children : <Navigate to="/dashboard" />;
}

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-amber-50">
      <Navbar />
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          {/* --- NEW UPDATE ADDED --- */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          {/* --- END UPDATE --- */}
          <Route path="/dashboard" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="/kyc-verification" element={
            <PrivateRoute>
              <KYCVerification />
            </PrivateRoute>
          } />
          <Route path="/education-hub" element={<EducationHub />} />
          <Route path="/marketplace" element={
            <PrivateRoute>
              <TradeMarketplace />
            </PrivateRoute>
          } />
          <Route path="/orders" element={
            <PrivateRoute>
              <OrderTracking />
            </PrivateRoute>
          } />
          <Route path="/list-product" element={
            <PrivateRoute>
              <ProductListing />
            </PrivateRoute>
          } />
          <Route path="/admin" element={
            <AdminRoute>
              <AdminPanel />
            </AdminRoute>
          } />
        </Routes>
      </Suspense>
      <Footer />
    </div>
  );
}

export default App;
